export default __webpack_public_path__ + "static/media/hw-service.3424cba6.jpg";